import Vue from "vue";
import App from "./App.vue";
import { http } from "@/utils/http";
import "@/assets/styles/base.scss";
import "@/config";
import "normalize.css";
import "vant/lib/index.css";
import store from "@/store/index.js";
import router from "@/router";
import wx from "weixin-js-sdk";
import MobileLoginDialog from '@/components/MobileLoginDialog.vue';
if (process.env.NODE_ENV != "production") {
  const VConsole = require("vconsole");
  new VConsole();
}
Vue.prototype.$wx = wx
Vue.config.productionTip = false;
Vue.prototype.$http = http;

// 全局挂载 $showLoginDialog 方法
const LoginDialogConstructor = Vue.extend(MobileLoginDialog);
let loginDialogInstance = null;
Vue.prototype.$showLoginDialog = function() {
  if (!loginDialogInstance) {
    loginDialogInstance = new LoginDialogConstructor();
    loginDialogInstance.$mount();
    document.body.appendChild(loginDialogInstance.$el);
  }
  loginDialogInstance.visible = true;
  loginDialogInstance.phone = '';
  loginDialogInstance.code = '';
};
new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
